export default __webpack_public_path__ + "static/media/graphics-04.61ef3768.png";